import React,{useState,useEffect} from 'react'
import { getBrandDataAPI, removeBrandApi, UpdateBrandAPI } from '../../../Api/PanelAdminServices'
import TableFixedPage from '../../../Components/TableFixedPage/TableFixedPage'
import BrandTabel from '../../Tables/Brand/BrandTabel/BrandTabel'
import {  Modal } from "react-bootstrap";
import Button from "../../Button/Button";
import { errorToast, succToast } from '../../../Utils/Toast/Toast';

const BrandListContainer = () => {
  const[BrandDataState,setBrandDataState]=useState(null)
  const[BrandInfoState,setBrandInfoState]=useState(null)
  const[ShowmodalState,setShowmodalState]=useState(null)
  const[ShowEditModalState,setShowEditModalState]=useState(null)
  const[PBrandName,setPBrandName]=useState(null)
  const[EBrandName,setEBrandName]=useState(null)
  const[loadingBtn,setLoadingBtn]=useState(false)
  const[disable,setDisable]=useState(false)
  useEffect(()=>{
    getBrandDataHandler()
  },[])
  const getBrandDataHandler=async()=>{
    getBrandDataAPI((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setBrandDataState(res.brand)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  }
  const showModalHandler = (value,data) => {
    setBrandInfoState(data)
    if(value===2){
        setShowmodalState(true)
    }
    if(value===1){
        setShowEditModalState(true)
        setPBrandName(data.pName)
        setEBrandName(data.eName)
    }
  };
  const HideModlaHandler=()=>{
    setShowmodalState(false)
    setShowEditModalState(false)
  }
  const RemoveDiscountHandler=()=>{
    setDisable(true)
    let info={
      id:BrandInfoState.id
    }
    removeBrandApi(info, (succ) => {
      if (succ.status === 1) {
        succToast(succ.message);
        setDisable(false)
        getBrandDataHandler()
        HideModlaHandler()
      } else {
        errorToast(succ.message);
        setDisable(false)
        }
      });
  }
  const EditeDBrandValueHandler=()=>{
    let info={
      id:BrandInfoState.id,
      brand_persian:PBrandName,
      brand_english:EBrandName,
      file:""
    }
    setLoadingBtn(true)
    UpdateBrandAPI(info, (succ) => {
        if (succ.status === 1) {
          succToast(succ.message);
          getBrandDataHandler()
          HideModlaHandler()
          setLoadingBtn(false)
        } else {
          errorToast(succ.message);
          setLoadingBtn(false)
        }
      });
  }

  return (
    <div>
      <TableFixedPage title={"لیست برندها"} />
      <Modal show={ShowmodalState} onHide={HideModlaHandler} >
        <Modal.Header>
          <Modal.Title style={{fontSize:'1rem',width:'100%',direction:'rtl'}}>
            آیا از حذف تخفیف موردنظر مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={HideModlaHandler}
              />
            <Button
              disabledprops={disable}
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={RemoveDiscountHandler}
            />
          </div>
        </Modal.Body>
      </Modal>
        <Modal show={ShowEditModalState} onHide={HideModlaHandler} >
        <Modal.Header>
          <Modal.Title style={{fontSize:'1rem',width:'100%',direction:'rtl'}}>
            ویرایش برند
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <section style={{display:'flex',flexDirection:'column',alignItems:'center',width:'100%'}}>
        <input
            style={{width:'98%',height:'3rem',borderRadius:'5px',margin:'0.5rem 0',textAlign:'right',border:'none',boxShadow:'0 1px 3px rgba(0, 0, 0, 0.253)'}}
              placeholder={"برند به فارسی"}
              onChange={e=>setPBrandName(e.target.value)}
              value={PBrandName}
            />
            <input
            style={{width:'98%',height:'3rem',borderRadius:'5px',margin:'0.5rem 0',textAlign:'right',border:'none',boxShadow:'0 1px 3px rgba(0, 0, 0, 0.253)'}}
              placeholder={"برند به انگلیسی"}
              onChange={e=>setEBrandName(e.target.value)}
              value={EBrandName}
            />
            <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
              margin:'1rem 0'
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"لغو"}
              ClickHandler={HideModlaHandler}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={loadingBtn?'منتظرباشید!':'ثبت'}
              ClickHandler={EditeDBrandValueHandler}
              disabledprops={loadingBtn}
              
            />
          </div>
        </section>
        </Modal.Body>
      </Modal>
      <BrandTabel openModal={showModalHandler} data={BrandDataState}/>
    </div>
  )
}

export default BrandListContainer